import React, { useState } from "react";
// import { ForgotIcon } from "helper/constant";
import NavigationActions from "redux/navigation/actions";
import enhancer from "../../../enhancers/ForgotPasswordEnhancer";
import { compose } from "redux";
import { connect } from "react-redux";
import { forgotPassword } from "services/adminServices";
import Loader from "components/Loader";
import { Link } from "react-router-dom";

const { success, error, fetching } = NavigationActions;

const ForgotPassword = props => {
  // const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    success,
    error,
    fetching,
    isValid,
    handleSubmit
  } = props;

  const handleForgotPassword = async e => {
    e.preventDefault();
    handleSubmit();
    if (isValid) {
      fetching();
      setLoading(true);
      await forgotPassword(values).then(data => {
        if (data.success) {
          success(data.message);
          setLoading(false);
        } else {
          error(data.message);
          setLoading(false);
        }
      });
    }
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="form-align">
        <div className="form-container login-form-container">
          <div className="login-icon">
            {/* <img src={ForgotIcon} alt="icon" height="100px" /> */}
          </div>
          <div className="login-title">Forgot Password ?</div>
          <div className="text-center form-info-text plr-24 mt-16">
            Provide your e-mail address to reset your password
          </div>
          <form className="pa-24" onSubmit={handleForgotPassword}>
            <div className="form-group">
              <input
                type="email"
                className="form-control react-form-input"
                id="email"
                aria-describedby="emailHelp"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                placeholder="Enter email"
              />
              <Error field="email" />
            </div>
            <button
              type="submit"
              className="btn form-button siteenterbutton"
              // disabled={isValid ? false : true}
            >
              Get Link
            </button>
            <div className="text-center mt-10">
              <Link to="/login">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    // isFetching: state.navigation.isFetching
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error, fetching })
)(ForgotPassword);
